import { STATIC_ASSETS_PLACEHOLDER } from "./staticAssetsPlaceholder.js";
// NOTE: STATIC_ASSETS_PLACEHOLDER will be replaced with
// config.cdn.STATIC_ASSETS_BASE_URL. Will convert them to absolute URLs before
// returning them in the response.
export const compilationSongs = [
    {
        id: "a-minor-waltz",
        name: "A Minor Waltz",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/A_Minor_Waltz.mp3`],
        duration: 135.941224,
    },
    {
        id: "auld-lang-syne",
        name: "Auld Lang Syne",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Auld_Lang_Syne.mp3`,
        ],
        duration: 120.659592,
    },
    {
        id: "avocado-street",
        name: "Avocado Street",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Avocado_Street.mp3`,
        ],
        duration: 221.4661,
    },
    {
        id: "ballerina",
        name: "Ballerina",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Ballerina.mp3`],
        duration: 147.826939,
    },
    {
        id: "birthday-cake",
        name: "Birthday Cake",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Birthday_Cake.mp3`],
        duration: 138.266122,
    },
    {
        id: "boardroom-theme",
        name: "Boardroom Theme",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Boardroom_Theme.mp3`,
        ],
        duration: 92.473469,
    },
    {
        id: "bright-skies",
        name: "Bright Skies",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Bright_Skies.mp3`],
        duration: 173.766531,
    },
    {
        id: "building-blocks",
        name: "Building Blocks",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Building_Blocks.mp3`,
        ],
        duration: 105.456327,
    },
    {
        id: "campfire-song",
        name: "Campfire Song",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Campfire_Song.mp3`],
        duration: 164.231837,
    },
    {
        id: "chords-of-harmony",
        name: "Chords of Harmony",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Chords_of_Harmony.mp3`,
        ],
        duration: 186.88,
    },
    {
        id: "christmas-village",
        name: "Christmas Village",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Christmas_Village.mp3`,
        ],
        duration: 90.592653,
    },
    {
        id: "corndogs-in-santa-monica",
        name: "Corndogs in Santa Monica",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Corndogs_in_Santa_Monica.mp3`,
        ],
        duration: 100.571429,
    },
    {
        id: "cute-avalanche",
        name: "Cute Avalanche",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Cute_Avalanche.mp3`,
        ],
        duration: 125.44,
    },
    {
        id: "daleys-reel",
        name: "Daley's Reel",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Daley_s_Reel.mp3`],
        duration: 179.983673,
    },
    {
        id: "deck-the-halls",
        name: "Deck the Halls",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Deck_the_Halls.mp3`,
        ],
        duration: 126.72,
    },
    {
        id: "distance",
        name: "Distance",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Distance.mp3`],
        duration: 170.161633,
    },
    {
        id: "dome-sweet-dome",
        name: "Banjo Sweet Banjo",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Dome_Sweet_Dome.mp3`,
        ],
        duration: 113.475918,
    },
    {
        id: "dulcinea",
        name: "Dulcinea",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Dulcinea.mp3`],
        duration: 161.018776,
    },
    {
        id: "dutty",
        name: "Dutty",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Dutty.mp3`],
        duration: 163.813875,
    },
    {
        id: "esthers-waltz",
        name: "Esther's Waltz",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Esthers_Waltz.mp3`],
        duration: 111.412245,
    },
    {
        id: "first-love",
        name: "First Love",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/First_Love.mp3`],
        duration: 101.302857,
    },
    {
        id: "fond-memories",
        name: "Fond Memories",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Fond_Memories.mp3`],
        duration: 196.989388,
    },
    {
        id: "fun-activity",
        name: "Fun Activity",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Fun_Activity_Montage.mp3`,
        ],
        duration: 103.653878,
    },
    {
        id: "get-outside",
        name: "Get Outside",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Get_Outside.mp3`],
        duration: 90.4359,
    },
    {
        id: "glen-canyon",
        name: "Glen Canyon",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Glen_Canyon.mp3`],
        duration: 153.39102,
    },
    {
        id: "good-times",
        name: "Good Times",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Good_Times.mp3`],
        duration: 120.084898,
    },
    {
        id: "happy-birthday-bossanova",
        name: "Happy Birthday Bossanova",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Happy_Birthday_Bossanova.mp3`,
        ],
        duration: 181.342041,
    },
    {
        id: "happy-birthday-bouncy",
        name: "Happy Birthday Bouncy",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Happy_Birthday_Bouncy.mp3`,
        ],
        duration: 165.720816,
    },
    {
        id: "happy-birthday-funk",
        name: "Happy Birthday Funk",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Happy_Birthday_Funk.mp3`,
        ],
        duration: 168.202449,
    },
    {
        id: "happy-birthday-jazz-waltz",
        name: "Happy Birthday Jazz Waltz",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Happy_Birthday_Jazz_Waltz.mp3`,
        ],
        duration: 164.440816,
    },
    {
        id: "happy-birthday-mambo",
        name: "Happy Birthday Mambo",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Happy_Birthday_Mambo.mp3`,
        ],
        duration: 184.711837,
    },
    {
        id: "happy-birthday-soul",
        name: "Happy Birthday Soul",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Happy_Birthday_Soul.mp3`,
        ],
        duration: 159.294694,
    },
    {
        id: "happy-mistake",
        name: "Happy Mistake",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Happy_Mistake.mp3`],
        duration: 180.035918,
    },
    {
        id: "homebound",
        name: "Homebound",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Homebound.mp3`],
        duration: 169.012245,
    },
    {
        id: "i-have-a-little-dreidel",
        name: "I Have a Little Dreidel",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/I_Have_a_Little_Dreidel.mp3`,
        ],
        duration: 112.483265,
    },
    {
        id: "jack-in-the-box",
        name: "Jack in the Box",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Jack_in_the_Box.mp3`,
        ],
        duration: 119.1706,
    },
    {
        id: "jingle-bells",
        name: "Jingle Bells",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Jingle_Bells.mp3`],
        duration: 144.274286,
    },
    {
        id: "joy-to-the-world",
        name: "Joy to the World",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Joy_to_the_World.mp3`,
        ],
        duration: 145.684898,
    },
    {
        id: "longer-distance",
        name: "Longer Distance",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Longer_Distance.mp3`,
        ],
        duration: 233.090612,
    },
    {
        id: "morning-mandolin",
        name: "Morning Mandolin",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Morning_Mandolin.mp3`,
        ],
        duration: 219.350204,
    },
    {
        id: "mosswood",
        name: "Mosswood",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Mosswood.mp3`],
        duration: 178.155102,
    },
    {
        id: "mr-sunny-face",
        name: "Mr. Sunny Face",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Mr_Sunny_Face.mp3`],
        duration: 101.381224,
    },
    {
        id: "new-year",
        name: "New Year",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/New_Year.mp3`],
        duration: 218.697143,
    },
    {
        id: "o-christmas-tree",
        name: "O Christmas Tree",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/O_Christmas_Tree.mp3`,
        ],
        duration: 163.317551,
    },
    {
        id: "piano-journey",
        name: "Piano Journey",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Piano_Journey.mp3`],
        duration: 110.550204,
    },
    {
        id: "put-on-your-dancing-pants",
        name: "Put On Your Dancing Pants",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Put_On_Your_Dancing_Pants.mp3`,
        ],
        duration: 158.876735,
    },
    {
        id: "roll-and-drop",
        name: "Roll and Drop",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Rollanddrop.mp3`],
        duration: 65.8808,
    },
    {
        id: "rolling-heads",
        name: "Rolling Heads",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Rolling_Heads.mp3`],
        duration: 221.622857,
    },
    {
        id: "ruination",
        name: "Ruination",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Ruination_2.mp3`],
        duration: 115.330612,
    },
    {
        id: "safety-net",
        name: "Safety Net",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Safety_Net.mp3`],
        duration: 87.222857,
    },
    {
        id: "silence-for-a-film",
        name: "Silence for a Film",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Silence_for_a_Film.mp3`,
        ],
        duration: 244.035918,
    },
    {
        id: "smile-quiet-looking-up",
        name: "Smile Quiet Looking Up",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Smile_Quiet_Looking_Up.mp3`,
        ],
        duration: 176.0653,
    },
    {
        id: "southern-california",
        name: "Southern California",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Southern_California.mp3`,
        ],
        duration: 133.87755,
    },
    {
        id: "spring-in-my-step",
        name: "Spring in my Step",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Spring_In_My_Step.mp3`,
        ],
        duration: 118.75265,
    },
    {
        id: "strong-bones",
        name: "Strong Bones",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Strong_Bones.mp3`],
        duration: 177.214694,
    },
    {
        id: "summer-symphony-ball",
        name: "Summer Symphony Ball",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Summer_Symphony_Ball.mp3`,
        ],
        duration: 200.85551,
    },
    {
        id: "sunshine",
        name: "Sunshine",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Sunshine.mp3`],
        duration: 140.329796,
    },
    {
        id: "swoop",
        name: "Swoop",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Swoop.mp3`],
        duration: 102.870204,
    },
    {
        id: "take-me-out-to-the-ballgame",
        name: "Take Me Out to the Ballgame",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Take_Me_Out_to_the_Ballgame.mp3`,
        ],
        duration: 192.679184,
    },
    {
        id: "the-creek",
        name: "The Creek",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/The_Creek.mp3`],
        duration: 211.121625,
    },
    {
        id: "the-only-girl",
        name: "The Only Girl",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/The_Only_Girl.mp3`],
        duration: 110.706925,
    },
    {
        id: "ukulele-beach",
        name: "Ukulele Beach",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Ukulele_Beach.mp3`],
        duration: 140.094694,
    },
    {
        id: "venice-beach",
        name: "Venice Beach",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Venice_Beach.mp3`],
        duration: 177.0057,
    },
    {
        id: "water-lily",
        name: "Water Lily",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Water_Lily.mp3`],
        duration: 129.619575,
    },
    {
        id: "we-wish-you-a-merry-christmas",
        name: "We Wish You a Merry Christmas",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/We_Wish_You_a_Merry_Christmas.mp3`,
        ],
        duration: 174.576327,
    },
    {
        id: "whispering-stream",
        name: "Whispering Stream",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Whispering_Stream.mp3`,
        ],
        duration: 183.24898,
    },
    {
        id: "wigs",
        name: "Wigs",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Wigs.mp3`],
        duration: 121.861224,
    },
    {
        id: "winds-of-spring",
        name: "Winds of Spring",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Winds_of_Spring.mp3`,
        ],
        duration: 174.602449,
    },
    {
        id: "wish-youd-come-true",
        name: "Wish You'd Come True",
        urls: [
            `${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Wish_Youd_Come_True.mp3`,
        ],
        duration: 169.273469,
    },
    {
        id: "yellow-jello",
        name: "Yellow Jello",
        urls: [`${STATIC_ASSETS_PLACEHOLDER}/compilations/songs/Yellow_Jello.mp3`],
        duration: 128.679184,
    },
];
export const compilationGenres = [
    {
        id: "pop",
        name: "Pop",
        songs: [
            "birthday-cake",
            "bright-skies",
            "corndogs-in-santa-monica",
            "cute-avalanche",
            "distance",
            "dutty",
            "first-love",
            "fond-memories",
            "fun-activity",
            "get-outside",
            "good-times",
            "happy-birthday-funk",
            "happy-birthday-mambo",
            "happy-birthday-soul",
            "happy-mistake",
            "homebound",
            "jack-in-the-box",
            "mr-sunny-face",
            "new-year",
            "put-on-your-dancing-pants",
            "roll-and-drop",
            "rolling-heads",
            "ruination",
            "safety-net",
            "southern-california",
            "spring-in-my-step",
            "strong-bones",
            "sunshine",
            "take-me-out-to-the-ballgame",
            "the-creek",
            "the-only-girl",
            "venice-beach",
            "water-lily",
            "wigs",
            "winds-of-spring",
            "wish-youd-come-true",
            "yellow-jello",
        ],
    },
    {
        id: "electronic",
        name: "Electronic",
        songs: [
            "boardroom-theme",
            "bright-skies",
            "corndogs-in-santa-monica",
            "distance",
            "dutty",
            "good-times",
            "homebound",
            "new-year",
            "roll-and-drop",
            "ruination",
            "silence-for-a-film",
            "smile-quiet-looking-up",
            "yellow-jello",
        ],
    },
    {
        id: "acoustic",
        name: "Acoustic",
        songs: [
            "a-minor-waltz",
            "auld-lang-syne",
            "avocado-street",
            "ballerina",
            "building-blocks",
            "campfire-song",
            "chords-of-harmony",
            "christmas-village",
            "cute-avalanche",
            "daleys-reel",
            "deck-the-halls",
            "dome-sweet-dome",
            "dulcinea",
            "esthers-waltz",
            "first-love",
            "fond-memories",
            "fun-activity",
            "glen-canyon",
            "good-times",
            "happy-birthday-bossanova",
            "happy-birthday-bouncy",
            "happy-birthday-funk",
            "happy-birthday-jazz-waltz",
            "happy-birthday-mambo",
            "i-have-a-little-dreidel",
            "jingle-bells",
            "joy-to-the-world",
            "longer-distance",
            "morning-mandolin",
            "mosswood",
            "o-christmas-tree",
            "piano-journey",
            "southern-california",
            "summer-symphony-ball",
            "sunshine",
            "swoop",
            "the-creek",
            "the-only-girl",
            "ukulele-beach",
            "venice-beach",
            "water-lily",
            "we-wish-you-a-merry-christmas",
            "whispering-stream",
            "wigs",
            "winds-of-spring",
            "yellow-jello",
        ],
    },
];
export const compilationMoods = [
    {
        id: "relaxed",
        name: "Relaxed",
        songs: [
            "a-minor-waltz",
            "auld-lang-syne",
            "avocado-street",
            "ballerina",
            "boardroom-theme",
            "bright-skies",
            "building-blocks",
            "campfire-song",
            "chords-of-harmony",
            "dulcinea",
            "esthers-waltz",
            "first-love",
            "glen-canyon",
            "happy-birthday-bossanova",
            "happy-birthday-bouncy",
            "happy-birthday-jazz-waltz",
            "jack-in-the-box",
            "jingle-bells",
            "joy-to-the-world",
            "longer-distance",
            "morning-mandolin",
            "mosswood",
            "mr-sunny-face",
            "new-year",
            "o-christmas-tree",
            "piano-journey",
            "rolling-heads",
            "silence-for-a-film",
            "smile-quiet-looking-up",
            "summer-symphony-ball",
            "sunshine",
            "swoop",
            "take-me-out-to-the-ballgame",
            "the-creek",
            "ukulele-beach",
            "water-lily",
            "we-wish-you-a-merry-christmas",
            "whispering-stream",
            "wigs",
            "winds-of-spring",
            "wish-youd-come-true",
        ],
    },
    {
        id: "upbeat",
        name: "Upbeat",
        songs: [
            "birthday-cake",
            "boardroom-theme",
            "bright-skies",
            "christmas-village",
            "corndogs-in-santa-monica",
            "cute-avalanche",
            "daleys-reel",
            "deck-the-halls",
            "distance",
            "dome-sweet-dome",
            "dutty",
            "fond-memories",
            "fun-activity",
            "get-outside",
            "good-times",
            "happy-birthday-funk",
            "happy-birthday-mambo",
            "happy-birthday-soul",
            "happy-mistake",
            "homebound",
            "i-have-a-little-dreidel",
            "jack-in-the-box",
            "jingle-bells",
            "mr-sunny-face",
            "new-year",
            "put-on-your-dancing-pants",
            "roll-and-drop",
            "rolling-heads",
            "ruination",
            "safety-net",
            "southern-california",
            "spring-in-my-step",
            "strong-bones",
            "sunshine",
            "swoop",
            "take-me-out-to-the-ballgame",
            "the-only-girl",
            "venice-beach",
            "water-lily",
            "we-wish-you-a-merry-christmas",
            "winds-of-spring",
            "yellow-jello",
        ],
    },
];
